var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16V10L8 8L0 6V0L14.3 6H14C12.05 6 10.396 6.68733 9.038 8.062C7.67933 9.43733 7 11.1 7 13.05L0 16ZM14 18C12.6167 18 11.4377 17.5127 10.463 16.538C9.48767 15.5627 9 14.3833 9 13C9 11.6167 9.48767 10.4373 10.463 9.462C11.4377 8.48733 12.6167 8 14 8C15.3833 8 16.5627 8.48733 17.538 9.462C18.5127 10.4373 19 11.6167 19 13C19 14.3833 18.5127 15.5627 17.538 16.538C16.5627 17.5127 15.3833 18 14 18ZM15.65 15.35L16.35 14.65L14.5 12.8V10H13.5V13.2L15.65 15.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchMessage);
export default __webpack_public_path__ + "static/media/schMessage.96925594bf8411e5d2c5ad259c92c153.svg";
export { ForwardRef as ReactComponent };